module.exports = __webpack_public_path__ + "img/boxImg.56bfbcac.png";